import { Component } from '@angular/core'
import { TableModule } from 'primeng/table'
import { CommonModule } from '@angular/common'
import { TranslateService } from '@ngx-translate/core'
import { AuthService } from '../../../../services/auth.service'

@Component({
  selector: 'app-user-infos',
  imports: [TableModule, CommonModule],
  templateUrl: './user-infos.component.html',
  styleUrl: './user-infos.component.scss',
})
export class UserInfosComponent {
  userInfos: Record<string, string> = {
    USERNAME: '',
    EMAIL: '',
    PROFILE: '',
  }
  translations: Record<string, string> = {}

  constructor(
    private translate: TranslateService,
    private authservice: AuthService,
  ) {}

  ngOnInit() {
    const userInfo = this.authservice.currentUserInfo()
    if (userInfo) {
      this.userInfos = {
        USERNAME: `${userInfo.firstName} ${userInfo.lastName}`,
        EMAIL: userInfo.email,
        PROFILE: userInfo.role ? userInfo.role.toLocaleUpperCase() : 'NO_ROLE',
      }
      const keysToTranslate = this.generateTranslationKeys()

      this.translate.get(keysToTranslate).subscribe((translations) => {
        this.translations = translations
      })
    }
  }

  private generateTranslationKeys(): string[] {
    const basePath = 'NAVBAR.MENU.USER_INFOS'
    const keys = Object.keys(this.userInfos)

    let translationKeys = keys.map((key) => `${basePath}.${key}`)

    if (this.userInfos['PROFILE']) {
      const profileValue = this.userInfos['PROFILE']
      translationKeys.push(`${basePath}.PROFILE_TYPES.${profileValue}`)
    }

    return translationKeys
  }

  get userInfoKeys(): string[] {
    return Object.keys(this.userInfos)
  }

  getTranslatedKey(key: string): string {
    const basePath = 'NAVBAR.MENU.USER_INFOS'
    return this.translations[`${basePath}.${key}`] || key
  }

  getTranslatedValue(key: string): string {
    const basePath = 'NAVBAR.MENU.USER_INFOS'

    if (key === 'PROFILE') {
      const profileValue = this.userInfos[key]
      return (
        this.translations[`${basePath}.PROFILE_TYPES.${profileValue}`] ||
        profileValue
      )
    }

    return this.userInfos[key]
  }
}
